import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {snakeKeys} from "../array";
import {Visit, VisitPreview} from "../../types/Visit";
import deserializeVisit from "./deserializers/visit";

type VisitFilters = {
    visitors?: string | number
    site?: number
    date?: string
    ongoing?: boolean
    sort?: string
    page?: number
    perPage?: number
}

/**
 * Get all visits that match the given filters (paginated)
 */
const filtered = async (filters: VisitFilters = {}) => {
    const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters))
    const response = await client.get<DataResource<VisitPreview> | null>('/visits', {params})

    if (response.data) {
        response.data.data = response.data.data.map(deserializeVisit)
    }

    return response.data
}

/**
 * Get a single visit
 *
 * @param {number} id
 */
const get = async (id: number) => {
    return deserializeVisit(
      (await client.get<Visit>(`/visits/${id}`)).data
    )
}

const visits = {
    get,
    filtered,
}

export default visits;